<template>
  <!-- 服务保障 -->
  <div class="content-item gray">
    <div class="content-items">
      <p class="title">服务保障</p>
      <span class="text">当换科技，以二手电子产品的回收、处置、销售为核心业务，致力于加速电子产品可循环效率，推动二手市场健康发展</span>
      <div class="service-list">
        <div class="service-item" v-for="(item, index) in serviceList" :key="index">
          <img :src="isMaxScreen ? item.image : item.image1" alt="">
          <span class="service-title">{{item.title}}</span>
          <span v-if="isMaxScreen">{{item.text}}</span>
          <span v-if="!isMaxScreen">{{item.text1}}</span>
          <span v-if="!isMaxScreen">{{item.text2}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      serviceList: [
        {
          image: require('../../assets/image/home/fuwu_zhencheng.png'),
          image1: require('../../assets/image/home/tiexin1.png'),
          title: '真诚贴心',
          text: '极致好价，贴心客服',
          text1: '',
          text2: ''
        },
        {
          image: require('../../assets/image/home/fuwu_anquan.png'),
          image1: require('../../assets/image/home/anquan1.png'),
          title: '安全信赖',
          text: '流程规范，隐私全清',
          text1: '',
          text2: ''
        },
        {
          image: require('../../assets/image/home/fuwu_gaoxiao.png'),
          image1: require('../../assets/image/home/gaoxiao1.png'),
          title: '高效便捷',
          text: '顺丰包邮，极速到账',
          text1: '',
          text2: ''
        },
        {
          image: require('../../assets/image/home/fuwu_zhuanye.png'),
          image1: require('../../assets/image/home/zhuanye1.png'),
          title: '专业品质',
          text: '官方保障，全球布局',
          text1: '',
          text2: ''
        }
      ]
    }
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen
      }
    })
  },
  methods: {
    changeIndex (index, item) {
      this.itemIndex = index
      // item.type === 1 ? this.$router.push(item.url) : window.open(item.url)
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (!this.isMaxScreen && this.isMaxScreen !== null) {
        this.serviceList.map(item => {
          item.text1 = item.text.split('，')[0]
          item.text2 = item.text.split('，')[1]
          return item
        })
      }
    })
  }
}
</script>

<style lang="less" scoped>
@media (max-width: 980px) {
  .home {
    width: 100%;
    padding: 0 24px;
    box-sizing: border-box;
    .content-item {
      display: flex;
      flex-direction: column;
      .content-items {
        padding-top: 55px;
        box-sizing: border-box;
        p {
          margin: 0;
          padding: 0;
          text-align: left;
          font-size: 32px;
        }
        .title {
          margin-bottom: 22px;
          font-size: 32px;
          line-height: 32px;
          color: #333;
          font-weight: 550;
        }
        .text {
          display: inline-block;
          color: #999;
          font-size: 24px;
          line-height: 32px;
          margin-bottom: 22px;
          text-align: left;
        }
        .service-list {
          display: flex;
          justify-content: space-between;
          cursor: pointer;
          .service-item {
            width: 167px;
            height: 260px;
            // margin-right: 11px;
            display: flex;
            flex-direction: column;
            background: #fff;
            border-radius: 20px;
            img {
              width: 100%;
              height: 150px;
            }
            span {
              font-size: 22px;
              line-height: 24px;
              color: #999;
            }
            .service-title {
              margin-top: 16px;
              margin-bottom: 10px;
              font-size: 26px;
              line-height: 24px;
              color: #333;
              font-weight: 530;
            }
          }
        }
      }
    }
  }
}
@media (min-width: 981px) {
  .home {
    width: 100%;
    .main-content {
      width: 100%;
      .white {
        background: white;
      }
      .gray {
        background: #F6F6F6;
      }
      .content-item {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .content-items {
        width: 1200PX;
        padding: 90PX 0;
        box-sizing: border-box;
        .title {
          font-size: 36PX;
          font-weight: 500;
          color: #111111;
          line-height: 36PX;
          text-align: center;
          margin: 0;
        }
        .text {
          display: inline-block;
          font-size: 22PX;
          margin-top: 20PX;
        }
        .service-list {
          margin-top: 55PX;
          display: flex;
          flex-wrap: wrap;
          align-content: space-between;
          // justify-content: space-between;
          // 服务
          .service-item {
            width: 282PX;
            height: 360PX;
            display: flex;
            flex-direction: column;
            background: #FFFFFF;
            border-radius: 20PX;
            margin-right: 24PX;
            img {
              width: 100%;
              height: 240PX;
            }
            span {
              font-size: 16PX;
              color: #666;
            }
            .service-title {
              display: inline-block;
              font-size: 24PX;
              line-height: 24PX;
              margin: 28PX 0 17PX 0;
              color: #333;
            }
          }
          .service-item:nth-child(4) {
            margin-right: 0;
          }
          // 业务规模
          .grade-item {
            width: 384PX;
            height: 310PX;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-right: 24PX;
            img {
              width: 160PX;
              height: 160PX;
              margin: 12px 0 20px 0;
            }
            .number {
              display: inline-block;
              font-size: 42PX;
              line-height: 42PX;
              font-weight: bold;
              color: #FF9600;
            }
          }
          .grade-item:nth-child(3) {
            margin-right: 0;
          }
          // 合作伙伴
          .partner-item {
            width: 196PX;
            height: 64PX;
            margin: 0PX 55PX 0 0;
            text-align: center;
            line-height: 64PX;
            img {
              width: 100%;
              height: 100%;
            }
            span {
              font-size: 18PX;
              color: #999;
            }
          }
          .partner-item:nth-child(5n) {
            margin-right: 0;
          }
        }
      }
    }
  }
}
</style>
